const VideoSiteTypeEnum = Object.freeze({
  YouTube: 'YouTube',
  Vimeo: 'Vimeo',
  Dailymotion: 'Dailymotion'
});

export default VideoSiteTypeEnum;
